// extracted by mini-css-extract-plugin
export default {"loader":"Loaders_loader__AReff","suspenseLoaderContainer":"Loaders_suspenseLoaderContainer__GW+g7"};